import { HttpInterceptorFn } from "@angular/common/http";

import { missingFacetsRedirectInterceptor } from "@hermes/domains-product-listing-states-product-listing-state";

export const APP_FUNCTIONAL_HTTP_INTERCEPTORS: HttpInterceptorFn[] = [
    missingFacetsRedirectInterceptor,
];
